import { isLocalDevHostname, resolveApiUrl } from '~/utils/resolveApiUrl';

/**
 * Browser URL for LE Data API (`/api/reporting/le-data/...`).
 *
 * - **Local**: `REPORTING_LE_DATA_SVC_ORIGIN` so traffic hits svc-reporting directly.
 * - **Other hosts** (test/prod): `API_HOST` via {@link resolveApiUrl}.
 */
export function resolveReportingLeDataUrl(path: string): string {
  if (typeof window === 'undefined') {
    return path.startsWith('/') ? path : `/${path}`;
  }

  const normalized = path.startsWith('/') ? path : `/${path}`;

  const base = String(window.configs?.REPORTING_LE_DATA_SVC_ORIGIN ?? '')
    .trim()
    .replace(/\/$/, '');

  if (base) {
    return `${base}${normalized}`;
  }

  if (isLocalDevHostname()) {
    throw new Error('REPORTING_LE_DATA_SVC_ORIGIN is required for local LE Data development');
  }

  return resolveApiUrl(normalized);
}
